export default "__VITE_ASSET__pDkk9k2t__"